// extracted by mini-css-extract-plugin
export var button = "section-tabs-module--button--ACmlr";
export var colored = "section-tabs-module--colored--mbjbW";
export var grid = "section-tabs-module--grid--VWKs5";